import { getAuth, connectAuthEmulator } from 'firebase/auth';
import app from './config';

// null, solange keine Firebase-Konfiguration vorliegt - siehe config.js.
// Jede Aufrufstelle muss damit rechnen.
const auth = app ? getAuth(app) : null;

// Opt-in, nur wenn explizit gesetzt (`REACT_APP_USE_EMULATORS=true npm start`).
// Standardverhalten bleibt Produktion - nie dauerhaft in .env.local setzen.
if (auth && process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
}

export default auth;
